import { ActionCreatorProps, createAction, props } from '@ngrx/store';

import { IDatiqAnalyticsEvent } from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq Panel] ${name}`;
};
const defaultAnalyticProps: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const selectedOptionItemName: string = createActionName(
    'selected option item'
);
export const selectedOptionItem = createAction(
    selectedOptionItemName,
    defaultAnalyticProps
);
